import { WidgetConfig } from '../../../models/widget.config';

export class SignWidgetConfig extends WidgetConfig<string> {
  widgetType = 'SignWidget';
  constructor(config: {} = {}) {
    super(config);
  }
}
